var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{class:[_vm.base.wrapper, _vm.base[_vm.align]],style:(_vm.width),on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{class:_vm.base.content},[_vm._t("default",[_vm._v("Add flyout content here")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }